import request from '@/utils/request'
export function getDayCount(data) {//创建
    return request({
        url: '/backend/appUser/dayCount/'+data.source,
        method: 'post',
    })
}

export function getMonthCount() {//创建
    return request({
        url: '/backend/appUser/lineCount',
        method: 'post',
    })
}

export function getLineCountThirty() {//创建
    return request({
        url: '/backend/appUser/lineCountThirty',
        method: 'post',
    })
}